import { type AuthState, type UserInToken } from '../common/types';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import authApi from './auth.api-slice';
import { extractFromSessionStorage } from '../common/helpers';
import { type RootState } from '../app/store';

const { user, token } = extractFromSessionStorage();
const initialAuthState: AuthState = { token, loggedIn: false, user };

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    login: (state, { payload: { token, user, loggedIn } }: PayloadAction<AuthState>) => {
      state.token = token;
      state.user = user;
      state.loggedIn = loggedIn;
    },

    logout: (state) => {
      state.token = null;
      state.loggedIn = false;
      state.user = null;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.loginUser.matchFulfilled, (state, { payload: { jwtToken, user } }) => {
      state.loggedIn = true;
      state.token = jwtToken;
      state.user = user;
    });
  }
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state: RootState): UserInToken | null => state.auth.user;
